export default "__VITE_ASSET__CV0uAChD__"